import { createAsyncThunk, createAction } from '@reduxjs/toolkit';

import type { Vendor } from '../../types';
import api from '../../services/api';
import { createHitViewEvent } from '../../services/algolia';
import { isTruthy } from '../../utils/types';

export const fetchSearchResults = createAsyncThunk(
  'search/fetchSearchResults',
  async ({ query, vendor }: { query: string; vendor: Vendor }) => {
    const { components } = await api.search.query({ query, vendor });

    const events = components
      .map((component) => {
        const { analytics: { algolia } = {} } = component;

        const objectIDs = component.data.preset.map((item) => String(item.id));

        if (algolia && objectIDs.length > 0) {
          return createHitViewEvent({
            indexName: algolia.indexName,
            objectIDs,
          });
        }

        return undefined;
      })
      .filter(isTruthy);

    if (events.length > 0) {
      api.search.sendEvents({ events, vendor });
    }

    return { components };
  }
);

export const cleanupSharedState = createAction('search/cleanupSharedState');
